import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module paragraph/paragraphcommand
 */
import { Command } from '@ckeditor/ckeditor5-core';
import { first } from '@ckeditor/ckeditor5-utils';
/**
 * The paragraph command.
 */
var ParagraphCommand = /*#__PURE__*/function (_Command) {
  _inherits(ParagraphCommand, _Command);
  var _super = _createSuper(ParagraphCommand);
  function ParagraphCommand(editor) {
    var _this;
    _classCallCheck(this, ParagraphCommand);
    _this = _super.call(this, editor);
    // Since this command may pass selection in execution block, it should be checked directly.
    _this._isEnabledBasedOnSelection = false;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ParagraphCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var document = model.document;
      var block = first(document.selection.getSelectedBlocks());
      this.value = !!block && block.is('element', 'paragraph');
      this.isEnabled = !!block && checkCanBecomeParagraph(block, model.schema);
    }
    /**
     * Executes the command. All the blocks (see {@link module:engine/model/schema~Schema}) in the selection
     * will be turned to paragraphs.
     *
     * @fires execute
     * @param options Options for the executed command.
     * @param options.selection The selection that the command should be applied to. By default,
     * if not provided, the command is applied to the {@link module:engine/model/document~Document#selection}.
     */
  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var selection = options.selection || document.selection;
      // Don't execute command if selection is in non-editable place.
      if (!model.canEditAt(selection)) {
        return;
      }
      model.change(function (writer) {
        var blocks = selection.getSelectedBlocks();
        var _iterator = _createForOfIteratorHelper(blocks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            if (!block.is('element', 'paragraph') && checkCanBecomeParagraph(block, model.schema)) {
              writer.rename(block, 'paragraph');
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);
  return ParagraphCommand;
}(Command);
/**
 * Checks whether the given block can be replaced by a paragraph.
 *
 * @param block A block to be tested.
 * @param schema The schema of the document.
 */
export { ParagraphCommand as default };
function checkCanBecomeParagraph(block, schema) {
  return schema.checkChild(block.parent, 'paragraph') && !schema.isObject(block);
}